import { cx } from '@vizit/theme';

interface CardHeaderProps extends React.HTMLAttributes<HTMLDivElement> {}

function CardHeader(props: CardHeaderProps) {
  const { children, className, ...rest } = props;

  return (
    <div className={cx('flex flex-col gap-4 p-8 relative', className)} {...rest}>
      {children}
    </div>
  );
}

export { CardHeader };
